import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, X, Instagram, Linkedin, Youtube } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    {
      title: 'Product',
      links: [
  { name: 'Features', href: '/features' },
  { name: 'Pricing', href: '/pricing' },
  { name: 'Download App', href: '/download' },
  { name: 'About Us', href: '/about' },
      ],
    },
    {
      title: 'Industries',
      links: [
  { name: 'Event Management', href: '/event-exhibition-parking-management' },
  { name: 'Cinema & Multiplex', href: '/cinema-and-multiplex-parking-system' },
  { name: 'Tourist Attractions', href: '/tourist-attraction-parking-software' },
  { name: 'Corporate Parks', href: '/parking-lot-management-app' },
      ],
    },
    {
      title: 'Solutions',
      links: [
  { name: 'Digital Parking', href: '/digital-parking-solutions' },
  { name: 'AI Management', href: '/ai-parking-management-platform' },
  { name: 'Revenue Management', href: '/parking-revenue-management-app' },
  { name: 'Automation Software', href: '/parking-lot-automation-software' },
  { name: 'Entry Exit System', href: '/vehicle-entry-exit-management-system' },

      ],
    },
    {
      title: 'Support',
      links: [
        { name: 'Contact', href: '/contact' },
        { name: 'Privacy Policy', href: '/privacypolicy' },
        { name: 'Help Center', href: '/contact' },
      ],
    },
  ];
  
  const socialLinks = [
    { icon: <Facebook className="h-5 w-5" />, href: 'https://www.facebook.com/profile.php?id=61583894451298' },
    { icon: <X className="h-5 w-5" />, href: 'https://x.com/nubes_tech' },
    { icon: <Instagram className="h-5 w-5" />, href: 'https://www.instagram.com/nubes_tech' },
    { icon: <Youtube className="h-5 w-5" />, href: 'https://www.youtube.com/@Nubes-Technologies' },
    { icon: <Linkedin className="h-5 w-5" />, href: 'https://www.linkedin.com/company/nubestechnologies/about/' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          <div className="lg:col-span-2">
            <div className="mb-4">
              <Logo />
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Transform your parking operations with Park Hive's intelligent, fully digital parking management system. Designed for high-traffic environments with real-time tracking, automated billing, and seamless customer experience.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>
          
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {(() => {
                      // treat as internal route if href starts with '/'
                      const isInternal = typeof link.href === 'string' && link.href.startsWith('/');
                      if (isInternal) {
                        return (
                          <Link
                            to={link.href}
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                            className="text-gray-400 hover:text-white transition-colors duration-200"
                          >
                            {link.name}
                          </Link>
                        );
                      }

                      return (
                        <a
                          href={link.href}
                          className="text-gray-400 hover:text-white transition-colors duration-200"
                        >
                          {link.name}
                        </a>
                      );
                    })()}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} Park Hive. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6">
            <a href="/privacypolicy" className="text-gray-500 hover:text-white text-sm transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="/contact" className="text-gray-500 hover:text-white text-sm transition-colors duration-200">
              Terms of Service
            </a>
            <a href="/contact" className="text-gray-500 hover:text-white text-sm transition-colors duration-200">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;